import NirServiceApi from './http/HttpNirServiceApi';

function nirServiceApi() {
  if (process.env.REACT_APP_NIR_API_URL) {
    return new NirServiceApi();
  }
  throw new Error(
    "No data api url specified. Use env property 'REACT_APP_NIR_API_URL' to define it."
  );
}

export default nirServiceApi();
